// src/components/EditarVendedor.jsx
import React, { useEffect, useState } from "react";
import { editarVendedor, obterVendedorPorId } from "../services/api";
import CadastroVendedor from "./CadastroVendedor";
import { useParams, useNavigate } from "react-router-dom";

const EditarVendedor = ({ token }) => {
  const [initialData, setInitialData] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await obterVendedorPorId(id, token);
        // seu backend pode retornar { vendedor, revendaNome } como em cliente
        const data = response.data?.vendedor ?? response.data?.Vendedor ?? response.data;
        setInitialData(data);
      } catch (error) {
        console.error("Erro ao carregar os dados do vendedor:", error);
      }
    };
    fetchData();
  }, [id, token]);

  const handleEditSubmit = async (data, token) => {
    try {
      await editarVendedor(id, data, token);
      alert("Vendedor atualizado com sucesso!");
      navigate("/vendedores");
    } catch (err) {
      const dataErr = err?.response?.data;

      if (typeof dataErr === "string") {
        alert(dataErr);
        return;
      }

      const message =
        dataErr?.message ||
        (dataErr?.errors && Object.values(dataErr.errors).flat().join("\n")) ||
        err.message ||
        "Erro ao atualizar vendedor.";

      alert(message);
      console.error(err);
    }
  };

  if (!initialData) return <div>Carregando...</div>;

  return (
    <CadastroVendedor
      token={token}
      initialData={initialData}
      onSubmit={handleEditSubmit}
      isEdit={true}
    />
  );
};

export default EditarVendedor;
